<ng-container *transloco="let t">
<div class="card mt-3 group-container-repeat">
  <div class="card-header bg-primary" [title]="scenario.productName">
    <h4 class="card-title text-white">{{ scenario.productName }}</h4>
  </div>
  <div class="card-body">
    <div class="text-muted text-scenario">
      <span class="card-text">
        <a class="inline-edit-link">
          <span class="fs-larger">
            {{ scenario.name ? scenario.name : t('portal.tasks.scenario') + " " + index }}
          </span>
        </a>
      </span>
    </div>
    <hr />
    <div class="text-muted">
      <span>
        {{
          scenario.pricingRequestPayload &&
          scenario.pricingRequestPayload.loanInformation
            ? (scenario.pricingRequestPayload.loanInformation.baseLoanAmount
              | currency)
            : ""
        }}
      </span>
    </div>
    <div>
      <span class="card-text text-muted"><strong>{{ t('portal.tasks.loanAmount') }}</strong></span>
    </div>
    <hr />
    <div class="text-muted">
      <span
        >{{
          scenario.pricingRequestPayload &&
          scenario.pricingRequestPayload.propertyInformation
            ? (scenario.pricingRequestPayload.propertyInformation.appraisedValue
              | currency)
            : ""
        }}
      </span>
    </div>
    <div>
      <span class="card-text text-muted"><strong>{{ t('portal.tasks.appraisedValue') }}</strong></span>
    </div>
    <hr />
    <div class="text-info">
      <span
        >{{
          scenario.adjustedRate
            ? (scenario.adjustedRate / 100 | percent : "1.3-3")
            : t('portal.tasks.unknown')
        }}
        /
        {{
          scenario.apr ? (scenario.apr / 100 | percent : "1.3-3") : t('portal.tasks.unknown')
        }}
      </span>
    </div>
    <div class="mt-1">
      <span class="pt-1 card-text text-info"><strong> {{ t('portal.tasks.rateApr') }}</strong></span>
    </div>
    <hr />
    <div class="mt-1">
      <div class="row">
        <span class="col-12 cut-notes text-muted text-start" title="{{scenario.borrowerNotes}}"
          >{{ t('portal.tasks.notes') }}: {{ scenario.borrowerNotes }}
        </span>
      </div>
    </div>
    <hr />
    @if (scenario.history.length > 0) {
      <div class="mt-2">
        <apx-chart
          #chart
          [series]="chartOptions.series"
          [labels]="chartOptions.labels"
          [chart]="chartOptions.chart"
          [dataLabels]="chartOptions.dataLabels"
          [xaxis]="chartOptions.xaxis"
          [yaxis]="chartOptions.yaxis"
          [grid]="chartOptions.grid"
          [markers]="chartOptions.markers"
          [stroke]="chartOptions.stroke"
        ></apx-chart>
      </div>
    }
    @if (scenario.history.length > 0) {
      <hr />
    }
    <div class="text-info">
      @if (scenario.adjustedPrice >= 100.0) {
        <span
          class="text-muted price-rebate"
          >{{ scenario.rebatePercent }} /
          {{ scenario.rebateDollars | currency }}</span
        >
      }
      @if (scenario.adjustedPrice < 100.0) {
        <span
          class="text-muted price-discount"
          >({{ scenario.discountPercent }}) / ({{
            scenario.discountDollars | currency
          }})</span
        >
      }
    </div>
    <div>
      <span class="card-text text-info"><strong> {{ t('portal.tasks.points') }} </strong> </span>
    </div>
    <hr />
    <div class="text-info">
      <span
        >{{
          scenario.principalAndInterest
            ? (scenario.principalAndInterest | currency)
            : t('portal.tasks.unknown')
        }}
        /
        {{
          scenario.totalPayment ? (scenario.totalPayment | currency) : t('portal.tasks.unknown')
        }}
        <i
          class="fas fa-info-circle ms-1"
          [ngbPopover]="templateTaxes"
          triggers="manual"
          #p1="ngbPopover"
          (click)="togglePopover(p1)"
        ></i>
      </span>
      <ng-template #templateTaxes>
        <scenario-taxes-editor [scenario]="scenario"> </scenario-taxes-editor>
      </ng-template>
    </div>
    <div>
      <span class="card-text text-info"
        ><strong>{{ t('portal.tasks.monthlyPiPiti') }}</strong>
      </span>
    </div>
    <hr />
    <div class="text-info">
      <span class="text-danger">
        {{ feesTotal | currency }} <strong> </strong>
      </span>
    </div>
    <div>
      <span class="card-text text-info"><strong> {{ t('portal.tasks.scenarioFees') }} </strong></span>
    </div>
    <hr />
    <div class="text-info">
      <span class="text-danger"
        >{{ prepaidFeesTotal | currency }}<strong> </strong>
      </span>
    </div>

    <div>
      <span class="card-text text-info"><strong> {{ t('portal.tasks.prepaids') }} </strong></span>
    </div>
    <hr />
    <div class="text-muted">
      <span>{{
        scenario.totalClosingCost
          ? (scenario.totalClosingCost | currency)
          : t('portal.tasks.unknown')
      }}</span>
    </div>
    <div>
      <span class="card-text text-muted"><strong> {{ t('portal.tasks.cashToClose') }} </strong></span>
    </div>
  </div>
</div>
</ng-container>
